var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.947,
    height: 104,
    id: "google-analytics",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9ab00",
    d: "M93.947 90.985a12.925 12.925 0 0 1-12.857 12.993 12.362 12.362 0 0 1-1.591-.09 13.255 13.255 0 0 1-11.312-13.434V13.523A13.26 13.26 0 0 1 79.52.089a12.909 12.909 0 0 1 14.426 12.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e37400",
    d: "M12.882 78.236A12.882 12.882 0 1 1 0 91.118a12.882 12.882 0 0 1 12.882-12.882Zm33.893-39.044a13.256 13.256 0 0 0-12.527 13.545v34.6c0 9.391 4.133 15.09 10.187 16.3a12.9 12.9 0 0 0 15.209-10.084 12.61 12.61 0 0 0 .257-2.6v-38.81A12.925 12.925 0 0 0 47 39.192h-.225Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/google-analytics.39e889611bb47cba1ab6241e2b1b0f6c.svg";
export { ForwardRef as ReactComponent };